import React from 'react';
import { colourString, randomColours, formatDate, ChevronIcon } from '@keplerco/core';
import { themedAssetUrl } from '../../../library/helpers/themed-asset-url';
import { useAppActions, useAppState } from '../../../overmind';
import analysisStyles from '../analysis.module.css';
import { PagePath } from '../../../navigation/navigation.enums';
import { CompletionStatusChip } from '../../../components/chips/completion-status.chip';
import { FetchType } from '../../../enums';
import classNames from 'classnames';
import { useKeplerNavigate } from '../../../navigation/guards/use-kepler-navigate';

export function PendingAssessmentsPage() {
  const keplerNavigate = useKeplerNavigate();

  const actions = useAppActions();
  const { forcedAssessments } = useAppState();

  return (
    <div className={analysisStyles.landingPage}>
      <figure className={analysisStyles.landingFigure}>
        <object data={themedAssetUrl('graphics/pie-graph.graphic.svg')} type="image/svg+xml">
          <img src={themedAssetUrl('graphics/pie-graph.graphic.svg')} alt="graph" />
        </object>
      </figure>

      <div className={analysisStyles.landingContent}>
        <h1>Pending assessments</h1>

        <p style={{ marginTop: 4, color: 'var(--text_1)' }}>You need to finish these assessments before moving forward.</p>

        <div className={analysisStyles.landingCards}>
          {forcedAssessments?.map((forcedAssessment, index) => (
            <div
              key={forcedAssessment.assessmentSlug}
              className={classNames('card', analysisStyles.landingCard)}
              style={{ borderLeftColor: colourString(randomColours[index % randomColours.length]) }}
              onClick={async () => {
                actions.startLoader({ path: PagePath.analysisPendingAssessments, type: FetchType.Sending });
                await actions.getAssessmentConfig(forcedAssessment.assessmentSlug);
                keplerNavigate(PagePath.analysisBase + PagePath.analysisPendingAssessmentsAssessment.replace(':assessmentSlug', forcedAssessment.assessmentSlug));
                actions.stopLoader(PagePath.analysisPendingAssessments);
              }}
            >
              <div>
                <h3>{forcedAssessment.assessmentName}</h3>
                {!!forcedAssessment.endDate && <small>Deadline: {formatDate(new Date(forcedAssessment.endDate))}</small>}
              </div>

              <CompletionStatusChip completionStatus={forcedAssessment.completionStatus} />

              <ChevronIcon tone="primary" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
